import humanizeDuration, { Options } from "humanize-duration";

import { dayjs } from "@holibob-packages/dayjs";
import { LANGUAGES } from "@holibob-packages/language";

const dayInMilliseconds = 86400000;

const config: Options = {
    fallbacks: ["en"],
    conjunction: " and ",
    serialComma: false,
    units: ["d", "h", "m"],
    unitMeasures: {
        d: dayInMilliseconds,
        h: 3600000,
        m: 60000,
    },
};
export const formatDuration = (duration: string | null, languageCode: string) => {
    const language = LANGUAGES.find((language) => languageCode.includes(language.codeShort));
    const languageCodeShort = language?.codeShort ?? "en";
    const milliseconds = dayjs
        .duration(duration ?? "P0D")
        .locale(languageCodeShort)
        .asMilliseconds();
    return humanizeDuration(milliseconds, {
        language: languageCodeShort,
        ...config,
        ...(milliseconds < 3 * dayInMilliseconds && {
            units: ["h", "m"],
        }),
    });
};
